import React from 'react';
import styles from './Skeletons.module.css';

function LineChartSkeleton() {
    return (
        <svg className={styles.lineChartSkeleton} viewBox="0 0 100 40" preserveAspectRatio="none">
            <defs>
                <linearGradient id="lineGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" stopColor="#e0e0e0" />
                    <stop offset="50%" stopColor="#d0d0d0" />
                    <stop offset="100%" stopColor="#e0e0e0" />
                </linearGradient>
            </defs>
            <path
                d="M 0 35 L 20 28 L 35 32 L 55 18 L 75 12 L 100 8"
                fill="none"
                stroke="url(#lineGradient)"
                strokeWidth="1.5"
                vectorEffect="non-scaling-stroke"
            />
        </svg>
    );
}

export default LineChartSkeleton;
